export const escapeParameterValue = value => value.replace(/([\^_%,"']|^-)/g, '^$1');
//# sourceMappingURL=escape_parameter_value.js.map